import { type Ref, ref } from "vue";
import apiSkobo from "@/helpers/api/apiSkobo";

export const usePeopleComposable = () => {
  const peopleCpr: Ref<unknown> = ref(null);

  const cprSearch = async (cprId: string) => {
    const response = await apiSkobo.get(`/SsnSearch?cpr=${cprId}`);

    peopleCpr.value = response.data;

    return response.data;
  };

  return {
    peopleCpr,
    cprSearch
  };
};
